import { useEffect, useRef, useState } from 'react';
import { InView } from 'react-intersection-observer';
import classNames from 'classnames/bind';

import styles from './Home.module.scss';
import SuggestVideo from '~/components/Videos/SuggestVideo';
// import { videoService } from '~/services';
// import TiktokLoading from '~/components/TiktokLoading';
// import SvgIcon from '~/components/SvgIcon';
import VideoContext from '~/Context/VideoContext';
import { mockVideos } from '~/configs/videos';

const cx = classNames.bind(styles);

function Home() {
    // State
    const [videoList, setVideoList] = useState([]);
    // const [page, setPage] = useState(Math.random() * 10);
    const [volume, setVolume] = useState(0.5);
    const [muted, setMuted] = useState(true);

    // Ref
    const inViewArr = useRef([]);

    // Set value for context
    const contextValue = {
        volumeState: [volume, setVolume],
        mutedState: [muted, setMuted],
        inViewArr: inViewArr.current,
    };

    // Call API to load video list
    useEffect(() => {
        const fetchVideoList = async () => {
            // const result = await videoService.getSuggestVideo(page);
            // console.log('result::', result);

            // Mock data
            // Mock data (内容在 src/configs/videos.js)
            const result = [...mockVideos];


            const shuffledResult = result.sort(() => Math.random() - 0.5);
            setVideoList([...shuffledResult]);
        };

        fetchVideoList();
    }, []);

    return (
        <VideoContext value={contextValue}>
            <div className={cx('wrapper')}>
                {videoList.map((video, index) => {
                    return (
                        <InView key={index} threshold={0.8}>
                            {({ inView, ref: observeRef }) => (
                                <SuggestVideo ref={observeRef} isInView={inView} videoInfo={video} videoId={index} />
                            )}
                        </InView>
                    );
                })}
                {/* <InView onChange={(inView) => inView && setPage(handleRandomPage(1, 10))}>
                    <SvgIcon className={cx('auto-load-more')} icon={<TiktokLoading />} />
                </InView> */}
            </div>
        </VideoContext>
    );
}

export default Home;
